import { z } from 'zod';
import { ZBaseIntegrationConfig } from './base.js';
export const MONDIAL_RELAY_INTEGRATION_NAME = 'mondial-relay';
/**
 * Mondial Relay API1 credentials. Both are required for a save (draft or
 * active): the backend live-validates them against the WSI4 search, so there is
 * no credential-less draft state (dashboard `beforeSave` mirrors this).
 */
export const ZMondialRelayCredentials = z.object({
    /** Mondial Relay "Enseigne" / code enseigne. */
    enseigne: z.string().min(1, 'Enseigne is required'),
    /** Mondial Relay "Clé privée" — used to sign WSI4 search requests. */
    privateKey: z.string().min(1, 'Private key is required'),
});
export const ZMondialRelaySettings = z.object({
    // Which Shopify shipping methods map to a Mondial Relay relay-point pickup.
    // The method title must contain a Mondial Relay pickup keyword (e.g. "point
    // de retrait") so the merchant's Mondial Relay app recognises the order.
    methods: z
        .array(z.object({
        shippingRateCode: z.string(),
        shippingMethodTitle: z.string(),
    }))
        .optional(),
    // Hide automatic lockers (APM), offering staffed relay points only. When set,
    // the checkout pickup search sends WSI4 `Action=MED` instead of the default
    // `24R`; labels are unaffected (shipments still ship with delivery mode 24R).
    hideLockers: z.boolean().optional(),
});
export const ZMondialRelayIntegrationConfig = ZBaseIntegrationConfig.extend(z.object({
    integrationName: z.literal(MONDIAL_RELAY_INTEGRATION_NAME),
    category: z.literal('shipping'),
    credentials: ZMondialRelayCredentials,
    settings: ZMondialRelaySettings,
}).shape);
//# sourceMappingURL=mondial-relay.js.map